// mapeamento de arquivos
import spg from "./informacoesSPG.json";
import fip from "./informacoesFIP.json";
import fic from "./informacoesFIC.json";
import se from "./informacoesSE.json";
import home from "./informacoesHome.json";
import anaisFic from "./informacoesAnaisFIC.json";
import anaisFip from "./informacoesAnaisFIP.json";
import anaisSe from "./informacoesAnaisSE.json";
import anaisSpg from "./informacoesAnaisSPG.json";

export const translationFiles = {
  spg,
  anaisSpg,
  fip,
  anaisFip,
  fic,
  anaisFic,
  se,
  anaisSe,
  home
};
